import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

/**
 * es para dar un valor por default.
 */
function resolveUrl(defaultUrl, customUrl) {
  return customUrl ?? defaultUrl;
}
/**
 * GET Detalles del periodo de la carga del Reporte del Reloj
 * @param {object} params
 * @returns {Promise<object[]>}
 */
const obtenerListaDeRegistros = async (defaultUrl, params, customUrl) => {
  try {
    const uri = resolveUrl(defaultUrl, customUrl);
    const response = await API.get(uri, { params });
    return response.data;
    // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Detalles del periodo de la carga del Reporte del Reloj
 * @param {number} id
 * @returns {Promise<object|null>}
 */
const obtenerUnRegistro = async (defaultUrl, id, customUrl) => {
  try {
    const uri = resolveUrl(defaultUrl, customUrl);
    const response = await API.get(`${uri}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Detalles del periodo de la carga del Reporte del Reloj
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
const crearRegistro = async (defaultUrl, values, customUrl) => {
  try {
    const uri = resolveUrl(defaultUrl, customUrl);
    const response = await API.post(uri, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Detalles del periodo de la carga del Reporte del Reloj
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
const actualizarRegistro = async (defaultUrl, id, values, customUrl) => {
  try {
    const uri = resolveUrl(defaultUrl, customUrl);
    const response = await API.patch(`${uri}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * Put Detalles del periodo de la carga del Reporte del Reloj
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
const reemplazarRegistro = async (defaultUrl, id, values, customUrl) => {
  try {
    const uri = resolveUrl(defaultUrl, customUrl);
    const url = id ? `${uri}${id}` : uri;
    const response = await API.put(url, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Detalles del periodo de la carga del Reporte del Reloj
 * @param {number} id
 * @returns {Promise<boolean>}
 */
const borrarRegistro = async (defaultUrl, id, customUrl) => {
  try {
    const uri = resolveUrl(defaultUrl, customUrl);
    const response = await API.delete(`${uri}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

const CRUDgeneric = (defaultUrl) => ({
  obtenerListaDeRegistros(params, url) {
    return obtenerListaDeRegistros(defaultUrl, params, url);
  },
  obtenerUnRegistro(id, url) {
    return obtenerUnRegistro(defaultUrl, id, url);
  },
  crearRegistro(data, url) {
    return crearRegistro(defaultUrl, data, url);
  },
  actualizarRegistro(id, data, url) {
    return actualizarRegistro(defaultUrl, id, data, url);
  },
  reemplazarRegistro(id, data, url) {
    return reemplazarRegistro(defaultUrl, id, data, url);
  },
  borrarRegistro(id, url) {
    return borrarRegistro(defaultUrl, id, url);
  },
  autorizarRegistro(id, customUrl) {
    return actualizarRegistro(defaultUrl, id, { estados_globales: ESTATUS_AUTORIZADO }, customUrl);
  },
});

export default CRUDgeneric;
